// extracted by mini-css-extract-plugin
export default {"left-col":"left-col_mEt9B","right-col":"right-col_DMU9q","filter-bar":"filter-bar_CEnm4","coupon-list-space":"coupon-list-space_GCxHd"};